import React, { useContext, useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Changepassword from "./Changepassword";
import { Mycontext } from "../context/context";

function Header({ handleLogout }) {
  const [userDropdown, setUserDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [isReportOpen, setIsReportOpen] = useState(false);
  const dropdownRef = useRef(null);
  const reportdropdownRef = useRef(null);
  const mobilereportdropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const mobileToggleRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const role = localStorage.getItem("role");
  const name = localStorage.getItem("name");
  const { creditBalance, hotelName, setCreditBalance, setHotelName } =
    useContext(Mycontext);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isLogoutButton = event.target.closest(".logout-button");
      const isMobileReportClick = mobilereportdropdownRef.current?.contains(
        event.target
      );
      const isDesktopReportClick = reportdropdownRef.current?.contains(
        event.target
      );
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !isLogoutButton
      ) {
        setUserDropdown(false);
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        mobileToggleRef.current &&
        !mobileToggleRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
      if (
        reportdropdownRef.current &&
        !reportdropdownRef.current.contains(event.target) &&
        !isMobileReportClick
      ) {
        setIsReportOpen(false);
      }

      // Close mobile report dropdown
      if (
        mobilereportdropdownRef.current &&
        !mobilereportdropdownRef.current.contains(event.target) &&
        !isDesktopReportClick
      ) {
        setIsReportOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown when a report link is clicked
  const handleReportLinkClick = () => {
    setIsReportOpen(false);
    setMobileMenuOpen(false);
  };

  const handleReportToggle = () => {
    setIsReportOpen(!isReportOpen);
  };

  const handleLogoutClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setUserDropdown(false);
    setMobileMenuOpen(false);
    handleLogout();
    navigate("/");
  };

  // Check if any report route is active
  const isAnyReportActive = () => {
    return location.pathname.startsWith("/report");
  };

  const navLinkClass = ({ isActive }) =>
    `block px-4 py-3 rounded-md text-base font-medium text-sm transition-colors duration-200 ${
      isActive
        ? "bg-indigo-50 text-indigo-600 font-semibold"
        : "text-gray-700 hover:bg-gray-100"
    }`;

  const desktopNavLinkClass = ({ isActive }) =>
    `font-medium px-3 py-2 rounded-md text-sm transition-colors duration-200 ${
      isActive
        ? "text-indigo-600 font-semibold bg-indigo-50"
        : "text-gray-600 hover:text-indigo-600 hover:bg-gray-50"
    }`;

  const reportListClass = ({ isActive }) =>
    `px-4 py-3 transition-all duration-200 border-b border-gray-100 last:border-b-0 flex items-center gap-3 text-sm ${
      isActive
        ? "text-indigo-600 font-semibold bg-indigo-50 border-indigo-100"
        : "text-gray-600 hover:text-indigo-600 hover:bg-gray-50"
    }`;

  return (
    <>
      {/* Desktop Header */}
      <header className="hidden md:block shadow-sm  w-full sticky top-0 bg-white z-20 border-b border-gray-100">
        <nav className="px-6 py-3 w-full h-[60px]">
          <div className="flex justify-between items-center mx-auto max-w-screen-2xl">
            <div className="flex items-center  md:space-x-0 lg:space-x-3 xl:space-x-8">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `flex items-center gap-2 font-bold text-sm sm:text-base ${
                    isActive
                      ? "text-indigo-600"
                      : "text-gray-600 hover:text-indigo-600"
                  } transition-colors duration-200`
                }
              >
                <div className="text-2xl font-heading text-primary-indigo flex items-center">
                  <i className="fas fa-hotel mr-2"></i>
                  Bookly
                </div>
              </NavLink>

              {role === "superAdmin" && (
                <NavLink to="/hotel" className={desktopNavLinkClass}>
                  Hotel Management
                </NavLink>
              )}
              {(role === "manager" || role === "view only") && (
                <>
                  <NavLink to="/room" className={desktopNavLinkClass}>
                    Room Management
                  </NavLink>
                  <NavLink to="/receptionist" className={desktopNavLinkClass}>
                    Staff Management
                  </NavLink>
                  <NavLink to="/guestdetail" className={desktopNavLinkClass}>
                    Guest Overview
                  </NavLink>
                  <NavLink to="/roomcleaning" className={desktopNavLinkClass}>
                    Room Cleaning
                  </NavLink>

                  {/* Report Dropdown */}
                  <div className="relative" ref={reportdropdownRef}>
                    <button
                      onClick={() => setIsReportOpen(!isReportOpen)}
                      className={`font-medium px-3 py-2 rounded-md text-sm transition-colors duration-200 flex items-center gap-1 ${
                        isReportOpen || isAnyReportActive()
                          ? "text-indigo-600 font-semibold bg-indigo-50"
                          : "text-gray-600 hover:text-indigo-600 hover:bg-gray-50"
                      }`}
                    >
                      <span>Report</span>
                      <i
                        className={`fas fa-chevron-down text-xs transition-transform duration-200 ${
                          isReportOpen ? "rotate-180" : ""
                        }`}
                      ></i>
                    </button>

                    {/* Dropdown Menu */}
                    {isReportOpen && (
                      <div className="absolute right-0 lg:left-0 top-full mt-1 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50 animate-fadeIn">
                        <NavLink
                          to="/report/incomplete-checkin"
                          onClick={handleReportLinkClick}
                          className={reportListClass}
                        >
                          <i className="fas fa-clipboard-list text-indigo-500 w-5 text-center"></i>
                          Incomplete CheckIn Data
                        </NavLink>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="flex items-center bg-white rounded-lg px-3 py-1.5 border border-gray-200 hover:border-blue-300 transition-all duration-200 shadow-sm">
                      <i className="fas fa-credit-card text-blue-500 mr-2 text-sm"></i>
                      <div className="flex items-center">
                        <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mr-1">
                          {creditBalance !== null
                            ? creditBalance.toLocaleString("en-IN")
                            : "0"}
                        </span>
                        <div
                          className={`h-2 w-2 rounded-full animate-pulse ${
                            creditBalance !== null && creditBalance < 1000
                              ? "bg-red-500"
                              : "bg-green-500"
                          }`}
                        ></div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {role === "receptionist" && (
                <>
                  <NavLink to="/guestdetail" className={desktopNavLinkClass}>
                    Guest Management
                  </NavLink>
                  <div className="relative" ref={reportdropdownRef}>
                    <button
                      onClick={() => setIsReportOpen(!isReportOpen)}
                      className={`font-medium px-3 py-2 rounded-md text-sm transition-colors duration-200 flex items-center gap-1 ${
                        isReportOpen || isAnyReportActive()
                          ? "text-indigo-600 font-semibold bg-indigo-50"
                          : "text-gray-600 hover:text-indigo-600 hover:bg-gray-50"
                      }`}
                    >
                      <span>Report</span>
                      <i
                        className={`fas fa-chevron-down text-xs transition-transform duration-200 ${
                          isReportOpen ? "rotate-180" : ""
                        }`}
                      ></i>
                    </button>

                    {/* Dropdown Menu */}
                    {isReportOpen && (
                      <div className="absolute right-0 lg:left-0 top-full mt-1 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50 animate-fadeIn">
                        <NavLink
                          to="/report/incomplete-checkin"
                          onClick={handleReportLinkClick}
                          className={reportListClass}
                        >
                          <i className="fas fa-clipboard-list text-indigo-500 w-5 text-center"></i>
                          Incomplete CheckIn Data
                        </NavLink>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="flex items-center bg-white rounded-lg px-3 py-1.5 border border-gray-200 hover:border-blue-300 transition-all duration-200 shadow-sm">
                      <i className="fas fa-credit-card text-blue-500 mr-2 text-sm"></i>
                      <div className="flex items-center">
                        <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mr-1">
                          {creditBalance !== null
                            ? creditBalance.toLocaleString("en-IN")
                            : "0"}
                        </span>
                        <div
                          className={`h-2 w-2 rounded-full animate-pulse ${
                            creditBalance !== null && creditBalance < 1000
                              ? "bg-red-500"
                              : "bg-green-500"
                          }`}
                        ></div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="flex items-center">
              <div ref={dropdownRef} className="relative">
                <button
                  type="button"
                  className="flex items-center gap-2 max-w-xs rounded-full focus:outline-none group"
                  onClick={() => setUserDropdown(!userDropdown)}
                  aria-expanded={userDropdown}
                  aria-haspopup="true"
                >
                  <div className="flex flex-col items-end">
                    <span className="text-sm font-medium text-gray-700 group-hover:text-indigo-600 transition-colors duration-200">
                      {name}
                    </span>
                    <span className="text-xs text-gray-500 capitalize">
                      {role}
                    </span>
                  </div>
                  <div className="h-9 w-9 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 group-hover:bg-indigo-200 transition-colors duration-200">
                    <svg
                      className="h-5 w-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </div>
                </button>

                {userDropdown && (
                  <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none animate-fadeIn">
                    <div className="py-1">
                      {/* Reset Password Button */}
                      <button
                        onClick={() => {
                          setShowChangePassword(true);
                          setUserDropdown(false);
                        }}
                        className="logout-button w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-indigo-600 transition-colors duration-200 flex items-center gap-2"
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                          />
                        </svg>
                        Reset Password
                      </button>
                      <button
                        onClick={handleLogoutClick}
                        className="logout-button w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-red-600 transition-colors duration-200 flex items-center gap-2"
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                          />
                        </svg>
                        Sign out
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Mobile Header */}
      <header className="md:hidden shadow-sm  w-full bg-white z-20 border-b border-gray-100">
        <nav className="px-4 py-3 w-full">
          <div className="flex justify-between items-center">
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none transition-colors duration-200"
              ref={mobileToggleRef}
              aria-controls="mobile-menu"
              aria-expanded={mobileMenuOpen}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setMobileMenuOpen(!mobileMenuOpen);
              }}
            >
              <span className="sr-only">Open main menu</span>
              {mobileMenuOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>

            <NavLink
              to="/"
              className={({ isActive }) =>
                `flex items-center gap-2 font-bold text-sm sm:text-lg ${
                  isActive ? "text-indigo-600" : "text-gray-800"
                }`
              }
            >
              <div className="text-2xl md:text-3xl font-heading text-primary-indigo flex items-center">
                <i className="fas fa-hotel mr-2"></i> Bookly
              </div>
            </NavLink>

            <div className="flex items-center space-x-3">
              {/* Credit Balance Display in Mobile Header (Visible always) */}
              {(role === "manager" ||
                role === "view only" ||
                role === "receptionist") && (
                <div className="flex items-center">
                  <div className="flex items-center bg-white rounded-lg px-3 py-1.5 border border-gray-200 shadow-sm">
                    <i className="fas fa-wallet text-blue-500 text-sm mr-2"></i>
                    <div className="flex flex-col">
                      <span className="text-xs text-gray-500 font-medium">
                        {creditBalance !== null ? creditBalance : "0"}
                      </span>
                      <div
                        className={`h-1 w-full rounded-full ${
                          creditBalance !== null && creditBalance < 1000
                            ? "bg-red-500"
                            : "bg-green-500"
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>
              )}
              <div ref={dropdownRef} className="relative">
                <button
                  type="button"
                  className="flex items-center max-w-xs rounded-full focus:outline-none"
                  onClick={() => setUserDropdown(!userDropdown)}
                  aria-expanded={userDropdown}
                  aria-haspopup="true"
                >
                  <div className="h-9 w-9 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600">
                    <svg
                      className="h-5 w-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </div>
                </button>

                {userDropdown && (
                  <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none animate-fadeIn z-30">
                    <div className="py-1">
                      <button
                        onClick={() => {
                          setShowChangePassword(true);
                          setUserDropdown(false);
                        }}
                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-indigo-600 transition-colors duration-200 flex items-center gap-2"
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                          />
                        </svg>
                        Reset Password
                      </button>
                      <button
                        onClick={handleLogoutClick}
                        className=" w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-red-600 transition-colors duration-200 flex items-center gap-2"
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                          />
                        </svg>
                        Sign out
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div
              ref={mobileMenuRef}
              className="absolute left-0 right-0 mt-2 py-1 bg-white shadow-lg rounded-b-md z-10 animate-slideDown"
            >
              <div className="px-2 pt-2 pb-3 space-y-1">
                {role === "superAdmin" && (
                  <NavLink
                    to="/hotel"
                    className={navLinkClass}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Hotel Management
                  </NavLink>
                )}
                {(role === "manager" || role === "view only") && (
                  <>
                    <NavLink
                      to="/room"
                      className={navLinkClass}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Room Management
                    </NavLink>
                    <NavLink
                      to="/receptionist"
                      className={navLinkClass}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Staff Management
                    </NavLink>
                    <NavLink
                      to="/guestdetail"
                      className={navLinkClass}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Guest Overview
                    </NavLink>
                    <NavLink
                      to="/roomcleaning"
                      className={navLinkClass}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Room Cleaning
                    </NavLink>

                    {/* Mobile Report Dropdown */}
                    <div className="relative" ref={mobilereportdropdownRef}>
                      <button
                        onClick={handleReportToggle}
                        className={`w-full text-left font-medium px-4 py-3 rounded-md text-sm transition-colors duration-200 flex items-center justify-between ${
                          isReportOpen || isAnyReportActive()
                            ? "text-indigo-600 font-semibold bg-indigo-50"
                            : "text-gray-600 hover:text-indigo-600 hover:bg-gray-50"
                        }`}
                      >
                        <span>Report</span>
                        <i
                          className={`fas fa-chevron-down text-xs transition-transform duration-200 ${
                            isReportOpen ? "rotate-180" : ""
                          }`}
                        ></i>
                      </button>

                      {/* Mobile Dropdown Menu */}
                      {isReportOpen && (
                        <div className="mt-1 bg-white rounded-lg shadow-md border border-gray-200 py-2">
                          <NavLink
                            to="/report/incomplete-checkin"
                            onClick={() => {
                              handleReportLinkClick();
                              setMobileMenuOpen(false);
                            }}
                            className={reportListClass}
                          >
                            <i className="fas fa-clipboard-list text-indigo-500 w-5 text-center"></i>
                            Incomplete CheckIn Data
                          </NavLink>

                          {/* <NavLink
                            to="/report/occupancy"
                            onClick={() => {
                              handleReportLinkClick();
                              setMobileMenuOpen(false);
                            }}
                            className={reportListClass}
                          >
                            <i className="fas fa-bed text-indigo-500 w-5 text-center"></i>
                            Occupancy Report
                          </NavLink>

                          <NavLink
                            to="/report/satisfaction"
                            onClick={() => {
                              handleReportLinkClick();
                              setMobileMenuOpen(false);
                            }}
                            className={reportListClass}
                          >
                            <i className="fas fa-star text-indigo-500 w-5 text-center"></i>
                            Guest Satisfaction
                          </NavLink>

                          <NavLink
                            to="/report/staff-performance"
                            onClick={() => {
                              handleReportLinkClick();
                              setMobileMenuOpen(false);
                            }}
                            className={reportListClass}
                          >
                            <i className="fas fa-user-check text-indigo-500 w-5 text-center"></i>
                            Staff Performance
                          </NavLink>

                          <NavLink
                            to="/report/service-usage"
                            onClick={() => {
                              handleReportLinkClick();
                              setMobileMenuOpen(false);
                            }}
                            className={reportListClass}
                          >
                            <i className="fas fa-concierge-bell text-indigo-500 w-5 text-center"></i>
                            Service Usage
                          </NavLink>

                          <NavLink
                            to="/report/monthly-summary"
                            onClick={() => {
                              handleReportLinkClick();
                              setMobileMenuOpen(false);
                            }}
                            className={reportListClass}
                          >
                            <i className="fas fa-calendar-alt text-indigo-500 w-5 text-center"></i>
                            Monthly Summary
                          </NavLink> */}
                        </div>
                      )}
                    </div>
                  </>
                )}
                {role === "receptionist" && (
                  <>
                    <NavLink
                      to="/guestdetail"
                      className={navLinkClass}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Guest Management
                    </NavLink>
                    {/* Mobile Report Dropdown */}
                    <div className="relative" ref={mobilereportdropdownRef}>
                      <button
                        onClick={handleReportToggle}
                        className={`w-full text-left font-medium px-4 py-3 rounded-md text-sm transition-colors duration-200 flex items-center justify-between ${
                          isReportOpen || isAnyReportActive()
                            ? "text-indigo-600 font-semibold bg-indigo-50"
                            : "text-gray-600 hover:text-indigo-600 hover:bg-gray-50"
                        }`}
                      >
                        <span>Report</span>
                        <i
                          className={`fas fa-chevron-down text-xs transition-transform duration-200 ${
                            isReportOpen ? "rotate-180" : ""
                          }`}
                        ></i>
                      </button>

                      {/* Mobile Dropdown Menu */}
                      {isReportOpen && (
                        <div className="mt-1 bg-white rounded-lg shadow-md border border-gray-200 py-2">
                          <NavLink
                            to="/report/incomplete-checkin"
                            onClick={() => {
                              handleReportLinkClick();
                              setMobileMenuOpen(false);
                            }}
                            className={reportListClass}
                          >
                            <i className="fas fa-clipboard-list text-indigo-500 w-5 text-center"></i>
                            Incomplete CheckIn Data
                          </NavLink>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </nav>
      </header>

      {showChangePassword && (
        <Changepassword setShowChangePassword={setShowChangePassword} />
      )}
    </>
  );
}

export default Header;
